export const WebServicesIndustryTabsDataArabic = {
    webDevPageIndustryContent: {
        defaultTabOpen: "الرعاية الصحية"
    },

    WebServicesIndustryTabsData: [
        "الرعاية الصحية",
        "التقنية المالية",
        "التجزئة والتجارة الإلكترونية",
        "العقارات",
        "السيارات",
        "التعليم",
        "التأمين",
        "اللوجستيات",
        "الترفيه",
        "الألعاب",
        "الشبكات الاجتماعية",
        "الاتصالات",
        "الطاقة",
    ],

    WebServicesIndustryTabsItemsData: [
        {
            tabName: "الرعاية الصحية",
            tabDes:
                "نحن نساعد في تحويل قطاع الرعاية الصحية من خلال تطبيقات الويب التي تجعل رعاية المرضى أبسط وأكثر كفاءة. سواء كان الأمر يتعلق بإدارة سجلات المرضى بشكل آمن، أو تمكين استشارات الرعاية الصحية عن بعد، أو تحسين العمليات، فإن حلولنا مصممة لتلبية احتياجات مقدمي الرعاية الصحية ومرضاهم.",
            objectives: [
                "إدارة بيانات المرضى بأمان وسهولة.",
                "إنشاء منصات رعاية صحية عن بعد يسهل الوصول إليها.",
                "تعزيز خدمات الرعاية الصحية بأدوات مبتكرة.",
            ],
            href: "/industries/healthcare",
            tabImage: "health-care-image.png",
        },
        {
            tabName: "التقنية المالية",
            tabDes:
                "تزدهر التقنية المالية بالابتكار، ونحن هنا لدفعها إلى الأمام. تطبيقات الويب لدينا تبسط العمليات المالية المعقدة، من أنظمة الدفع الآمنة إلى أدوات التخطيط المالي. إنها مصممة لتمكين الشركات، وتعزيز تجارب العملاء، والحفاظ على كل شيء آمنًا على طول الطريق.",
            objectives: [
                "تبسيط المعاملات المالية الآمنة.",
                "بناء منصات قابلة للتطوير للشركات النامية.",
                "تحسين رضا العملاء بتصاميم بديهية.",
            ],
            href: "/industries/fintech",
            tabImage: "Fintech.png"
        },
        {
            tabName: "التجزئة والتجارة الإلكترونية",
            tabDes:
                "يجب أن يكون التسوق عبر الإنترنت سلسًا، وتطبيقات الويب لدينا تضمن ذلك. من تجارب التسوق المخصصة إلى إدارة المخزون المتقدمة، نساعد الشركات على التواصل مع العملاء، وزيادة مبيعاتها، وإنشاء انطباعات دائمة.",
            objectives: [
                "إنشاء منصات تسوق ديناميكية.",
                "البقاء على اطلاع دائم بالمخزون والطلبات في الوقت الفعلي.",
                "إشراك العملاء بميزات مخصصة",
            ],
            href: "/industries/retail-ecommerce",
            tabImage: "Retail-ecommerce.png"
        },
        {
            tabName: "العقارات",
            tabDes:
                "لم يكن العثور على العقارات وإدارتها أسهل من أي وقت مضى. باستخدام تطبيقات الويب لدينا، يمكنك تقديم جولات افتراضية، وإدارة علاقات العملاء، ومساعدة المشترين والبائعين على التواصل بسلاسة. نحن نبني أدوات تجعل المتخصصين في العقارات متقدمين بخطوة واحدة.",
            objectives: [
                "عرض العقارات بجولات افتراضية.",
                "تبسيط عمليات البحث عن العقارات بأدوات سهلة الاستخدام.",
                "تقوية علاقات العملاء بمنصات سهلة الاستخدام.",
            ],
            href: "/industries/real-estate",
            tabImage: "Realestate.png"
        },
        {
            tabName: "السيارات",
            tabDes:
                "صناعة السيارات تتحرك بسرعة، وتطبيقات الويب لدينا تواكبها. سواء كان الأمر يتعلق بتتبع المركبات، أو إدارة المخزون، أو التفاعل مع العملاء، فإننا ننشئ حلولًا تبسط العمليات وتحسن التجربة الكلية.",
            objectives: [
                "تتبع المركبات بأنظمة متقدمة.",
                "إدارة المخزون والخدمات بكفاءة.",
                "تعزيز تجارب العملاء بأدوات ذكية.",
            ],
            href: "/industries/automotive",
            tabImage: "automotive.png"
        },
        {
            tabName: "التعليم",
            tabDes:
                "يجب أن يكون التعليم جذابًا ومتاحًا، وتطبيقات الويب لدينا تحقق ذلك. من منصات التعلم الإلكتروني إلى أدوات إدارة الفصول الدراسية، نصمم حلولًا تلبي احتياجات الطلاب والمعلمين والمؤسسات، وتقرب الجميع من النجاح.",
            objectives: [
                "بناء أدوات تعليم إلكتروني تفاعلية وجذابة.",
                "تبسيط المهام الإدارية للمؤسسات.",
                "تخصيص تجربة التعلم للطلاب.",
            ],
            href: "/industries/education",
            tabImage: "education.png"
        },
        {
            tabName: "التأمين",
            tabDes:
                "نجعل عمليات التأمين سلسة وخالية من المتاعب. تطبيقات الويب لدينا تبسط المطالبات، وتدير السياسات، وتحسن التواصل مع العملاء. تم تصميم هذه الحلول الآمنة والفعالة للتكيف مع الاحتياجات المتغيرة باستمرار لقطاع التأمين.",
            objectives: [
                "تبسيط إدارة المطالبات وتتبعها.",
                "التعامل مع بيانات السياسات الحساسة بشكل آمن.",
                "تحسين تفاعل العملاء بأدوات أفضل.",
            ],
            href: "/industries/insurance",
            tabImage: "Insurance.png"
        },
        {
            tabName: "اللوجستيات",
            tabDes:
                "الكفاءة هي العمود الفقري للوجستيات، ونحن هنا لتحقيقها. تطبيقات الويب لدينا تبسط سلاسل التوريد من خلال التتبع في الوقت الفعلي، وإدارة الأسطول، والتحكم في المخزون. تبقى الشركات منظمة والعملاء على اطلاع، في كل خطوة على الطريق.",
            objectives: [
                "تتبع الشحنات في الوقت الفعلي.",
                "إدارة الأساطيل والمخزون بسهولة.",
                "الحفاظ على سير العمليات بسلاسة مع حلول ذكية.",
            ],
            href: "/industries/logistics",
            tabImage: "logistics.avif"
        },
        {
            tabName: "الترفيه",
            tabDes:
                "الترفيه يدور حول خلق تجارب لا تُنسى، وتطبيقات الويب لدينا تجعل ذلك ممكنًا. سواء كان الأمر يتعلق بالبث المباشر، أو الألعاب، أو المحتوى التفاعلي، فإننا نصمم حلولًا تأسر الجماهير وتقدم أداءً سلسًا.",
            objectives: [
                "بناء منصات قابلة للتطوير لبث المحتوى.",
                "إشراك المستخدمين بميزات تفاعلية.",
                "تقديم تجارب ترفيهية مخصصة.",
            ],
            href: "/industries/entertainment",
            tabImage: "entertainment.avif"
        },
        {
            tabName: "الألعاب",
            tabDes:
                "الألعاب تدور حول الإثارة، وتطبيقات الويب لدينا تأخذها إلى مستوى آخر. نحن نبني منصات تقدم طريقة لعب غامرة، وتفاعلات في الوقت الفعلي، وحلولًا قابلة للتطوير لمجتمعات الألعاب المتنامية.",
            objectives: [
                "إنشاء منصات متعددة اللاعبين بميزات في الوقت الفعلي.",
                "بناء أدوات لتجارب غامرة وجذابة.",
                "دعم قواعد المستخدمين المتنامية بتصاميم قابلة للتطوير.",
            ],
            href: "/industries/gaming",
            tabImage: "gaming.png"
        },
        {
            tabName: "الشبكات الاجتماعية",
            tabDes:
                "ربط الناس أكثر أهمية من أي وقت مضى، وتطبيقات الويب لدينا تجعل الأمر أسهل. ننشئ منصات لبناء المجتمعات، ومشاركة المحتوى، وتعزيز التفاعلات الهادفة. كل شيء مصمم للحفاظ على تفاعل المستخدمين وتواصلهم.",
            objectives: [
                "تعزيز بناء المجتمع بأدوات تفاعلية.",
                "تبسيط مشاركة الوسائط المتعددة للمستخدمين.",
                "إنشاء منصات تنمو مع احتياجات المستخدمين.",
            ],
            href: "/industries/social-networking",
            tabImage: "social-networking.png"
        },
        {
            tabName: "الاتصالات",
            tabDes:
                "صناعة الاتصالات تدور حول البقاء على اتصال، وتطبيقات الويب لدينا تساعد في تحقيق ذلك. من تبسيط الاتصالات إلى إدارة خدمات العملاء، نصمم حلولًا تبقي مزودي الاتصالات في المقدمة في صناعة سريعة التطور.",
            objectives: [
                "إدارة الشبكات وخدمات العملاء بكفاءة.",
                "توفير أنظمة آمنة للفواتير والبيانات.",
                "تعزيز أدوات الاتصال لتجارب مستخدم أفضل.",
            ],
            href: "/industries/telecom",
            tabImage: "Telecom.png"
        },
        {
            tabName: "الطاقة",
            tabDes:
                "تحتاج إدارة الطاقة إلى حلول أكثر ذكاءً، ونحن نقدمها. تطبيقات الويب لدينا تحسن الموارد، وتراقب الاستخدام، وتدعم جهود الاستدامة. سواء كان الأمر يتعلق بإدارة الشبكة أو تحليلات الطاقة، فإننا نساعدك على تشغيل عمليات أكثر سلاسة وصداقة للبيئة.",
            objectives: [
                "مراقبة استهلاك الطاقة في الوقت الفعلي.",
                "بناء أدوات قابلة للتطوير لإدارة الشبكة.",
                "دعم الاستدامة بتحليلات ذكية.",
            ],
            href: "/industries/energy",
            tabImage: "Energy.png"
        },
    ]
}